/* eslint-disable no-unused-vars */
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import { apiServerUrl } from '../../config/config.json';

const url = `${apiServerUrl}/users`;

String.prototype.allReplace = function(obj) {
  var retStr = this;
  for (var x in obj) {
    retStr = retStr.replace(new RegExp(x, "g"), obj[x]);
  }
  return retStr;
};

let messageConfig = {
  "<p>": "&lt;span&gt;",
  "</p>": "&lt;/span&gt;",
  'class="mention"':
    'class="mention" style="font-weight: bold; display: inline;"',
};

let messageConfigDecrypt = {
  "&lt;": "<",
  "&gt;": ">",
};

const state = {
  users: [],
  unassigned_permissions: [],
  assigned_permissions: [],
  unassigned_positions: [],
  assigned_positions: [],
  unassigned_offices: [],
  assigned_offices: [],
  user_taggings: [],
  mentions: [],
  unviewed_mentions: [],
  users_by_office: [],
  userCount: null,
  user_assigned_route: [],
  user_assigned_subroute: [],
  users_route: []
};

const getters = {
  allUsers: (state) => state.users,
  getAllUsersRoutes: (state) => state.users_route,
  getAssignedRoute: (state) => state.user_assigned_route,
  getAssignedSubRoute: (state) => state.user_assigned_subroute,
  getAssignedPermissions: (state) => state.assigned_permissions,
  getUnassignedPermissions: (state) => state.unassigned_permissions,
  getAssignedPositions: (state) => state.assigned_positions,
  getUnassignedPositions: (state) => state.unassigned_positions,
  getAssignedOffices: (state) => state.assigned_offices,
  getUnassignedOffices: (state) => state.unassigned_offices,
  getUserTaggings: (state) => state.user_taggings,
  getUserMentions: (state) => state.mentions,
  getUnviewedMentions: (state) => state.unviewed_mentions,
  allUsersByOffice: (state) => state.users_by_office,
  totalUserCount: (state) => state.userCount,
};

const actions = {
  async fetchUsers({ commit }, payload) {
    try {
      let limit = payload.itemsPerPage;

      let hasFilter = "";

      if (payload.filter) {
        hasFilter = "&filter=" + payload.filter;
      }

      const url1 = url + "?limit=" + limit + hasFilter;
      const authToken = localStorage.getItem("access_token");

      const response = await axios.get(url1, {
        headers: { "x-drmms-token": authToken },
      });

      let users = {};

      if (response.data.rows) {
        users = {
          count: response.data.count,
          rows: response.data.rows.map((user) => ({
            ...user,
            name: `${user.first_name} ${user.middle_name} ${user.last_name}`,
            date: moment(user.createdAt).format("LLL"),
          })),
        };
      } else {
        users = {
          count: response.data.length,
          rows: response.data.map((user) => ({
            ...user,
            name: `${user.first_name} ${user.middle_name} ${user.last_name}`,
            date: moment(user.createdAt).format("LLL"),
          })),
        };
      }

      commit("setUsers", users);
    } catch (err) {
      console.log(err);
    }
  },
  async fetchUsersInOffice({ commit }, filter) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(`${url}/office`, {
        headers: { "x-drmms-token": authToken },
      });

      let offices = [];
      response.data.forEach((office, index) => {
        let user_name;

        if(office.users.length > 0) {
          user_name = `${office.users[0].first_name} ${office.users[0].middle_name} ${office.users[0].last_name}`;
          offices.push(
            Object.assign(office, {
              select_name: `${office.name} - ${user_name}`,
              user_id: office.users[0].id,
              user_name,
            })
          );
        }
        
      });

      commit("setUsersByOffice", offices);
    } catch (err) {
      console.log(err);
    }
  },
  async createUser({ commit }, body) {
    let permissions = [];

    if (body.permission_group_select) {
      body.permission_group_select.permissions.forEach((element) => {
        permissions.push(element);
      });
    } else {
      permissions = state.assigned_permissions;
    }

    body = _.omit(body, ["permission_group_select"]);

    body = Object.assign(body, { permissions });
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(url, body, {
        headers: { "x-drmms-token": authToken },
      });
      let user = response.data;
      user = Object.assign(user, {
        name: `${user.first_name} ${user.middle_name} ${user.last_name}`,
        date: moment(user.createdAt).format("LLL"),
      });
      commit("addUser", user);
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 400)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async userUpdate({ commit }, body) {
    let permissions;

    if (body.permission_group_select) {
      let addPerm = [];
      let deletePerm = [];
      body.permission_group_select.permissions.forEach((element) => {
        addPerm.push(element);
      });

      state.assigned_permissions.forEach((element) => {
        deletePerm.push(element);
      });

      permissions = {
        add: addPerm,
        delete: deletePerm,
      };
    } else {
      let add_permissions = state.assigned_permissions.filter(
        (checkPermission) => checkPermission.isAssigned === false
      );
      let delete_permissions = state.unassigned_permissions.filter(
        (checkPermission) => checkPermission.isAssigned === true
      );

      permissions = {
        add: add_permissions,
        delete: delete_permissions,
      };
    }
    let office_id = _.get(body, "office_id", "");
    let position_id = _.get(body, "position_id", "");
    let current = _.get(body, "currentData", "");
    body = _.omit(body, [
      "office_id",
      "position_id",
      "currentData",
      "permission_group_select",
    ]);

    let checkPosition =
      current.positions.length == 0 ? false : current.positions[0];
    let checkOffice = current.offices.length == 0 ? false : current.offices[0];

    if (position_id) {
      if (!checkPosition) body = Object.assign(body, { position_id });
      else if (position_id != checkPosition.id)
        body = Object.assign(body, { position_id });
    }

    if (office_id) {
      if (!checkOffice) body = Object.assign(body, { office_id });
      else if (office_id != checkOffice.id)
        body = Object.assign(body, { office_id });
    }

    body = Object.assign(body, { permissions });

    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "put",
        url: `${url}/${body.user_id}`,
        data: body,
        headers: { "x-drmms-token": authToken },
      });
      let user = response.data.user;
      user = Object.assign(user, {
        name: `${user.first_name} ${user.middle_name} ${user.last_name}`,
        date: moment(user.createdAt).format("LLL"),
      });
      commit("updateUser", user);
      commit("userAssignment", response.data)
      return true;
    } catch (err) {
      console.log(err);
      if (err.response) {
        if (err.response.status == 400)
          return { error: true, status: 400, message: err.response.data };
        else if (err.response.status == 400)
          return { error: true, status: 500, message: "Internal Server Error" };
      }
    }
  },
  async deleteUser({commit}, ids) {
    try {
      const authToken = localStorage.getItem('access_token');
      const response = await axios({
        method: 'delete',
        url,
        data: { ids },
        headers: { 'x-drmms-token' : authToken}
      })
      commit('deleteUsers', ids)
    } catch (err) {
      console.log(err)
    }
  },
  async fetchUnassignedPermissions({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/unassignedPermissions`, body, {
        headers: { "x-drmms-token": authToken },
      });
      state.assigned_permissions = body.permissions.map((permission) => ({
        ...permission,
        isAssigned: true,
        color: "green",
      }));

      let unassigned = response.data.map((permission) => ({
        ...permission,
        isAssigned: false,
        color: "red",
      }));
      commit("setUnassignedPermissions", unassigned);
    } catch (err) {
      console.log(err);
    }
  },
  addPermission({ commit }, permission) {
    commit("addPermission", permission);
  },
  removePermission({ commit }, permission) {
    commit("removePermission", permission);
  },
  async saveUpdatedPermissions({ commit }, id) {
    let add_permissions = state.assigned_permissions.filter(
      (checkPermission) => checkPermission.isAssigned === false
    );
    let delete_permissions = state.unassigned_permissions.filter(
      (checkPermission) => checkPermission.isAssigned === true
    );

    let body = {
      user_id: id,
      add: add_permissions,
      delete: delete_permissions,
    };

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: "put",
        url: `${url}/assignPermission`,
        headers: { "x-drmms-token": authToken },
        data: body,
      });
      commit("updatePermissions", id);
      return true;
    } catch (err) {
      if (err.response)
        return { error: true, status: 500, message: "Internal Server Error" };
      console.log(err);
    }
  },
  async fetchUnassignedPositions({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/unassignedPositions`, body, {
        headers: { "x-drmms-token": authToken },
      });
      state.assigned_positions = body.positions.map((position) => ({
        ...position,
        isAssigned: true,
      }));

      let unassigned = response.data.map((position) => ({
        ...position,
        isAssigned: false,
      }));
      commit("setUnassignedPositions", unassigned);
    } catch (err) {
      console.log(err);
    }
  },
  addPosition({ commit }, permission) {
    commit("addPosition", permission);
  },
  removePosition({ commit }, permission) {
    commit("removePosition", permission);
  },
  async saveUpdatedPositions({ commit }, id) {
    let add_positions = state.assigned_positions.filter(
      (checkPosition) => checkPosition.isAssigned === false
    );
    let delete_positions = state.unassigned_positions.filter(
      (checkPosition) => checkPosition.isAssigned === true
    );

    let body = {
      user_id: id,
      add: add_positions,
      delete: delete_positions,
    };

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: "put",
        url: `${url}/assignPosition`,
        headers: { "x-drmms-token": authToken },
        data: body,
      });
      commit("updatePositions", id);
      return true;
    } catch (err) {
      if (err.response)
        return { error: true, status: 500, message: "Internal Server Error" };
      console.log(err);
    }
  },
  async fetchUnassignedOffices({ commit }, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.post(`${url}/unassignedOffices`, body, {
        headers: { "x-drmms-token": authToken },
      });
      state.assigned_offices = body.offices.map((office) => ({
        ...office,
        isAssigned: true,
      }));

      let unassigned = response.data.map((office) => ({
        ...office,
        isAssigned: false,
      }));
      commit("setUnassignedOffices", unassigned);
    } catch (err) {
      console.log(err);
    }
  },
  addOffice({ commit }, office) {
    commit("addOffice", office);
  },
  removeOffice({ commit }, office) {
    commit("removeOffice", office);
  },
  async saveUpdatedOffices({ commit }, id) {
    let add_offices = state.assigned_offices.filter(
      (checkOffice) => checkOffice.isAssigned === false
    );
    let delete_offices = state.unassigned_offices.filter(
      (checkOffice) => checkOffice.isAssigned === true
    );

    let body = {
      user_id: id,
      add: add_offices,
      delete: delete_offices,
    };

    try {
      const authToken = localStorage.getItem("access_token");
      let response = await axios({
        method: "put",
        url: `${url}/assignOffice`,
        headers: { "x-drmms-token": authToken },
        data: body,
      });
      commit("updateOffices", id);
      return true;
    } catch (err) {
      if (err.response)
        return { error: true, status: 500, message: "Internal Server Error" };
      console.log(err);
    }
  },
  async fetchUserTaggings({ commit }) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(`${url}?limit=0`, {
        headers: { "x-drmms-token": authToken },
      });
      let users = [];

      users = response.data.rows.map((user) => ({
        userId: user.id,
        id: `@${user.first_name} ${user.middle_name} ${user.last_name}`,
        name: `${user.first_name} ${user.middle_name} ${user.last_name}`,
      }));

      commit("setUserTaggings", users);
    } catch (err) {
      console.log(err);
    }
  },
  async fetchTags({ commit }) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios.get(`${url}/tags`, {
        headers: { "x-drmms-token": authToken },
      });
      let users = [];

      let tags = [];
      let mentions = response.data;

      let notViewedMentions = [];

      mentions.tags.forEach((element) => {
        if (!element.mentions[0].isViewed)
          notViewedMentions.push(element.mentions[0].id);

        if (element.route_comment_id != null) {
          let formatMessage = element.route_comment.message.allReplace(
            messageConfigDecrypt
          );
          element.msg = formatMessage;
          let formatName = `${element.route_comment.user.first_name} ${element.route_comment.user.last_name}`;
          element.user = formatName;

          tags.push(element);
        } else {
          let formatMessage = element.assigned_route_comment.message.allReplace(
            messageConfigDecrypt
          );
          element.msg = formatMessage;
          let formatName = `${element.assigned_route_comment.user.first_name} ${element.assigned_route_comment.user.last_name}`;
          element.user = formatName;

          tags.push(element);
        }

        tags.push({ divider: true, inset: true });
      });

      state.unviewed_mentions = notViewedMentions;
      commit("setTags", tags);
    } catch (err) {
      console.log(err);
    }
  },
  async viewUserTags({ commit }) {
    let currentUnviewed = state.unviewed_mentions;

    if (currentUnviewed.length > 0) {
      try {
        const authToken = localStorage.getItem("access_token");
        const response = await axios({
          method: "put",
          url: `${url}/update/view/tags`,
          headers: { "x-drmms-token": authToken },
          data: { ids: currentUnviewed },
        });

        commit("viewedUserTags", response.data);
      } catch (err) {
        console.log(err);
      }
    } else {
      return true;
    }
  },
  async reAssignUsers({commit}, body) {
    try {
      const authToken = localStorage.getItem("access_token");
      const response = await axios({
        method: "post",
        url: `${url}/reAssignRoutes`,
        headers: { "x-drmms-token": authToken},
        data: body
      })

      console.log(response)
      return true
    } catch( err ) {
      console.log(err)
      return err
    }
  } 
};

const mutations = {
  setUsers: (state, users) => {
    state.users = users.rows;
    state.userCount = users.count;
  },
  deleteUsers: (state, ids) => {
    for(let i = 0; i< ids.length; i++){
      state.users = state.users.filter(user => user.id !== ids[i])
    }
  },
  addUser: (state, user) => {
    let newUsers = state.users;
    state.users = [];
    newUsers.push(user);
    state.users = newUsers;
  },
  userAssignment: (state, data) => {
    state.user_assigned_route = data.route_ids
    state.user_assigned_subroute = data.subroute_ids
    state.users_route = data.allRoutes
  },
  updateUser: (state, user) => {
    const index = state.users.findIndex(
      (checkUser) => checkUser.id === user.id
    );
    // if(index !== -1) {
    state.users.splice(index, 1, user);
    // }
  },
  setUnassignedPermissions: (state, permissions) =>
    (state.unassigned_permissions = permissions),
  addPermission: (state, permission) => {
    state.assigned_permissions.push(permission);
    state.unassigned_permissions = state.unassigned_permissions.filter(
      (checkPermission) => checkPermission.id !== permission.id
    );
  },
  removePermission: (state, permission) => {
    state.unassigned_permissions.push(permission);
    state.assigned_permissions = state.assigned_permissions.filter(
      (checkPermission) => checkPermission.id !== permission.id
    );
  },
  updatePermissions: (state, id) => {
    const index = state.users.findIndex((user) => user.id === id);
    if (index !== -1) {
      let updated = state.users[index];
      updated.permissions = state.assigned_permissions;
      state.users.splice(index, 1, updated);
      state.unassigned_permissions = [];
      state.assigned_permissions = [];
    }
  },
  setUnassignedPositions: (state, positions) =>
    (state.unassigned_positions = positions),
  addPosition: (state, position) => {
    state.assigned_positions.push(position);
    state.unassigned_positions = state.unassigned_positions.filter(
      (checkPosition) => checkPosition.id !== position.id
    );
  },
  removePosition: (state, position) => {
    state.unassigned_positions.push(position);
    state.assigned_positions = state.assigned_positions.filter(
      (checkPosition) => checkPosition.id !== position.id
    );
  },
  updatePositions: (state, id) => {
    const index = state.users.findIndex((user) => user.id === id);
    if (index !== -1) {
      let updated = state.users[index];
      updated.positions = state.assigned_positions;
      state.users.splice(index, 1, updated);
      state.unassigned_positions = [];
      state.assigned_positions = [];
    }
  },
  setUnassignedOffices: (state, offices) =>
    (state.unassigned_offices = offices),
  addOffice: (state, office) => {
    state.assigned_offices.push(office);
    state.unassigned_offices = state.unassigned_offices.filter(
      (checkOffice) => checkOffice.id !== office.id
    );
  },
  removeOffice: (state, office) => {
    state.unassigned_offices.push(office);
    state.assigned_offices = state.assigned_offices.filter(
      (checkOffice) => checkOffice.id !== office.id
    );
  },
  updateOffices: (state, id) => {
    const index = state.users.findIndex((user) => user.id === id);
    if (index !== -1) {
      let updated = state.users[index];
      updated.offices = state.assigned_offices;
      state.users.splice(index, 1, updated);
      state.unassigned_positions = [];
      state.assigned_positions = [];
    }
  },
  setUserTaggings: (state, users) => (state.user_taggings = users),
  setTags: (state, users) => (state.mentions = users),
  viewedUserTags: (state, tags) => (state.unviewed_mentions = []),
  setUsersByOffice: (state, users) => (state.users_by_office = users),
};

export default {
  state,
  getters,
  actions,
  mutations,
};
